import { Component, OnDestroy, OnInit } from '@angular/core';
import { Footer } from '../../core/components/footer/footer';
import { Header } from '../../core/components/header/header';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-public-layout',
  imports: [Footer, Header, RouterOutlet],
  templateUrl: './public-layout.html',
  styleUrl: './public-layout.scss'
})
export class PublicLayout implements OnInit, OnDestroy{

  constructor() {
  }
  
  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }
}
